export { default as de } from './de.js'
export { default as en } from './en.js'
export { default as es } from './en.js'
export { default as it } from './en.js'
export { default as pl } from './en.js'
export { default as nl } from './en.js'




// WEBPACK FOOTER //
// ./src/i18n/profile/index.js